// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__11PYi","sendOtp":"AuthorizeToLogin_sendOtp__2nuSi"};